import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import messagesFrench from '../config/fr.json';

i18next.use(initReactI18next).init({
    debug: true,
    lng: 'fr',
    fallbackLng: 'fr',
    resources: {
        fr: {
            translation: messagesFrench,
        },
    },
    keySeparator: false,
});
export default i18next;
